const faqs = [
  {
    q: "How do I submit an ESMP?",
    a: "Go to your dashboard, open the ESMP form, attach the required files, then submit. You’ll see it appear in your Submitted ESMPs list.",
  },
  {
    q: "What do the statuses mean (Submitted / Pending / Overdue / Returned / Approved)?",
    a: "Submitted means it was sent. Pending means it’s waiting for review. Overdue means it passed the expected timeline. Returned means changes are requested. Approved means it’s completed.",
  },
  {
    q: "Why can’t I edit my ESMP after submitting?",
    a: "Most workflows lock editing once submitted to preserve audit history. If it’s Returned, you can update and resubmit.",
  },
  {
    q: "How do notifications work?",
    a: "In-app notifications appear in the Notifications page. If email notifications are enabled for your role, you may also receive email updates.",
  },
  {
    q: "How do I reset my password?",
    a: "Open Privacy and use the password reset form. You’ll need your current password to set a new one.",
  },
  {
    q: "Who do I contact for help?",
    a: "Use Contact Developer to report issues and feedback, or contact your administrator for account/role changes.",
  },
];

export default function FaqCard() {
  return (
    <div className="space-y-3">
      {faqs.map((item) => (
        <details
          key={item.q}
          className="group border border-gray-200 dark:border-gray-700 rounded-lg p-4 bg-white/50 dark:bg-gray-900/20"
        >
          <summary className="cursor-pointer list-none flex items-center justify-between gap-3">
            <span className="text-sm font-semibold text-gray-800 dark:text-gray-100">{item.q}</span>
            <span className="text-xs text-gray-500 group-open:hidden">Show</span>
            <span className="text-xs text-gray-500 hidden group-open:inline">Hide</span>
          </summary>
          <div className="mt-3 text-sm text-gray-600 dark:text-gray-300">{item.a}</div>
        </details>
      ))}
    </div>
  );
}

